import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { obtenerCotizacionDeGuia } from "app/logic/guias";
import { CotizacionView } from "../../../guias/index";

type Entity = models.GuiaDTO;

export interface Props {
    value: Entity;
}


class ClienteDestinoOrigen extends React.PureComponent<{ clienteDestino: string, direccionOrigen: string, clienteOrigen: string }> {
    render() {
        return (
            <div>
                <b>Origen: {this.props.clienteOrigen}</b>
                <br />
                <i>     {this.props.direccionOrigen}</i>
                <hr />
                <b style={{ color: "blue" }}>{this.props.clienteDestino}</b>
                <br />
            </div>
        );
    }
}
const ClienteDestinoRx = componentToRx(ClienteDestinoOrigen);


export class GuiaView extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    cotizacion = createSelectorRx(this.value, value => obtenerCotizacionDeGuia(value));
    destino = createSelectorRx(this.value, value => value.NombreClienteDestino);
    cliOrigen = createSelectorRx(this.value, value => value.NombreClienteOrigen);
    dirOrigen = createSelectorRx(this.value, value => value.DireccionOrigenDTO.Descripcion);
    render() {
        const { value } = this.props;
        const cotiz = obtenerCotizacionDeGuia(value);

        const clienteDestino = this.destino(this.props);
        const clienteOrigen = this.cliOrigen(this.props);
        const dirOrigen = this.dirOrigen(this.props);

        return (
            <kea.Panel title={
                <span>
                    <label style={{ fontFamily: "monospace" }} >{value.Folio}</label>

                    {value.FletePorCobrar &&
                    <span className="label label-danger">FXC</span>
                    }
                </span>
            }>

                <ClienteDestinoOrigen clienteOrigen={clienteOrigen} clienteDestino={clienteDestino} direccionOrigen={dirOrigen} />
                <CotizacionView value={cotiz} />
            </kea.Panel>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/ocurre/componentes/guias/ocurreguiaview.tsx